// Status constants for filtering

export const PLANNING_FORM_2_STATUSES = {
  IN_PROGRESS: ['created', 'reopened'],
  SUBMITTED: 'submitted',
  APPROVED: ['approved', 'approvedalternate'],
  FOLLOWUP: 'followup',
};

export const PLANNING_FORM_1_STATUSES = {
  IN_PROGRESS: ['created', 'returned'],
  SUBMITTED: 'submitted',
  APPROVED: ['approved', 'approvedalternate'],
  FOLLOWUP: 'followup',
};

export const CHECKLIST_STATUSES = {
  IN_PROGRESS: ['created', 'returned'],
  SUBMITTED: 'submitted',
  APPROVED: 'approved',
  FOLLOWUP: 'followup',
};
